import { render } from "./PostDetall.vue?vue&type=template&id=dbb330c0&ts=true"
import script from "./PostDetall.vue?vue&type=script&lang=ts"
export * from "./PostDetall.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__